module.exports = ".full-width {\n  width: 100%; }\n\n.HandCursor {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/tecnicasdiagnosticas/tecnicasdiagnosticasdetalle/tecnicasdiagnosticasdetalle.component.scss
// module id = ./src/app/consulta/tecnicasdiagnosticas/tecnicasdiagnosticasdetalle/tecnicasdiagnosticasdetalle.component.scss
// module chunks = main